import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { Select, Box } from '@nerdwallet/currency';
import AwardsBadgeDropdownOutput from './awards-badge-dropdown-output';

import './awards-badge-dropdown.less';
import { DATA_SOURCE } from './data';
import {
  stringSelectSpec,
  stringInputSpec,
  boolCheckboxSpec,
} from '../../lib/editing-configs';
import { detectContrast } from './lib/color-helper';
import BackgroundColor from '../background-color/background-color';

class AwardsBadgeDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectValue: '',
      displayDropdownToggle: false,
    };

    this.handleDropdownChange = this.handleDropdownChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.awardsYear !== this.props.awardsYear) {
      this.resetState();
    }
  }

  handleDropdownChange(e) {
    this.setState({
      selectValue: e.target.value,
    });
    if (!this.state.displayDropdownToggle) {
      this.state.displayDropdownToggle = true;
    }
  }

  resetState = () => {
    this.setState({
      selectValue: '',
      displayDropdownToggle: false,
    });
  };

  render() {
    const { hexColor, awardsYear, bgOptions, boldAwardsSelect } = this.props;

    const { displayDropdownToggle: displayDropdown, selectValue } = this.state;
    const companySelected = selectValue !== 'N/A';
    const data = DATA_SOURCE[awardsYear];
    let selectStyle = { backgroundColor: hexColor };
    if (boldAwardsSelect) {
      selectStyle = { ...selectStyle, fontWeight: 'bold' };
    }
    return (
      <BackgroundColor bgOptions={bgOptions}>
        {(backgroundColor) => (
          <div
            style={{ backgroundColor }}
            className={classNames([
              'awards-dropdown',
              classes('padding-bottom-5'),
            ])}
          >
            <Box
              className={classNames([
                'awards-dropdown__content',
                classes('margin-top-0'),
                classes('margin-bottom-3'),
                classes('margin-horizontal-auto'),
                classes('display-flex'),
                classes('flex-direction-column'),
                classes('align-items-center'),
              ])}
            >
              <Select
                id="dropdown"
                value=""
                className={detectContrast(hexColor, 0.7)}
                style={selectStyle}
                onChange={this.handleDropdownChange}
                options={data.map((company) => ({
                  label: `${company.name}`,
                  value: `${company.id}`,
                }))}
              />
            </Box>
            {displayDropdown && companySelected ? (
              <AwardsBadgeDropdownOutput
                id={selectValue}
                awardsYear={awardsYear}
              />
            ) : null}
          </div>
        )}
      </BackgroundColor>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
AwardsBadgeDropdown.propTypes = {
  bgOptions: BackgroundColor.propTypes.bgOptions,
  hexColor: PropTypes.string,
  awardsYear: PropTypes.string,
  boldAwardsSelect: PropTypes.bool,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
AwardsBadgeDropdown.defaultProps = {
  hexColor: '#fff',
  awardsYear: '2021',
};

AwardsBadgeDropdown.getEditingConfig = (componentDocument) => [
  ...BackgroundColor.getEditingConfig(componentDocument),
  stringInputSpec(
    'hexColor',
    'Dropdown Background HEX color (eg: "#D8D9DA" - default is #fff)'
  ),
  boolCheckboxSpec(
    'boldAwardsSelect',
    'Add bold style to dropdown placeholder?'
  ),
  stringSelectSpec('awardsYear', 'Awards Year (default is 2021)', [
    { label: '2021', value: '2021' },
    { label: '2020', value: '2020' },
    { label: '2022', value: '2022' },
  ]),
];

export default AwardsBadgeDropdown;
